import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  deleteMessageSuccessTitle: {
    id: 'frontbucket.dashboard.deleteMessageSuccessTitle',
    description: 'Text for the title of the delete repo success message',
    defaultMessage: 'Repository deleted',
  },
  deleteMessageDescription: {
    id: 'frontbucket.dashboard.deleteMessageDescription',
    description:
      'Text for the description of the delete repo success message. The repository name is wrapped in <bold> tags so it can be visually emphasised.',
    defaultMessage: '<bold>{repoName}</bold> was successfully deleted.',
  },
  deleteUnknownRepoDescription: {
    id: 'frontbucket.dashboard.deleteUnknownRepoDescription',
    description: 'Text for the description of the delete repo success message',
    defaultMessage: 'Repository was successfully deleted.',
  },
});
